import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import Transaction from '../../components/Transaction';

// Graphql
import getTransactionHistory from './getTransactionHistory.graphql';
import { withQuery } from '../../hoc/withGraphql';

import cs from '../../components/commonStyle.css'
import s from './Transaction.css';

const TransactionContainer = (props) => {

  const { data, mode } = props;
  return (
    <Grid fluid className={'listingContainer'}>
      <Row>
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
          <Transaction data={data} page={mode} />
        </Col>
      </Row>
    </Grid>
  );
}

TransactionContainer.propTypes = {
  data: PropTypes.object.isRequired
};

export default compose(
  withStyles(cs, s),
  withQuery(getTransactionHistory,
    {
      options: (props) => ({
        variables: {
          mode: props.mode,
          currentPage: 1,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(TransactionContainer);